// File: voces-de-esperanza/src/config/registration.js
//
// Interruptor único de altas de cuenta. Mientras la plataforma se termina de construir,
// los registros están cerrados: el formulario de "Crea tu cuenta" no se renderiza y el
// botón "Registrarse" abre en su lugar la invitación al boletín (es por ahí que avisamos
// cuando abran). Los inicios de sesión de cuentas existentes NO se tocan.
//
// Poner en `true` restaura el flujo completo (formulario de registro + alta con Google
// para cuentas nuevas) sin tocar ningún otro archivo. La puerta se aplica en dos capas:
//   1. UI — src/pages/mi-cuenta.js (AuthForm)
//   2. Servicio — src/services/auth-service.js (registerUser / signInWithGoogle)
// La segunda es la que importa: sin ella, "Continuar con Google" seguiría creando cuentas
// nuevas por la puerta de atrás.
export const REGISTRATION_OPEN = false;

// Código de error propio que lanza auth-service cuando alguien intenta crear cuenta con
// los registros cerrados. La UI lo intercepta para mostrar la invitación al boletín.
export const REGISTRATION_CLOSED_CODE = "auth/registration-closed";
